import React from 'react';
import { Facebook, Instagram, Linkedin, Youtube } from 'lucide-react';

const TikTok = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5 2.6 2.6 0 0 1-2.6-2.6 2.6 2.6 0 0 1 3.37-2.48V9.66a5.73 5.73 0 0 0-.77-.05A5.69 5.69 0 0 0 4.17 15.3 5.69 5.69 0 0 0 9.86 21a5.69 5.69 0 0 0 5.68-5.69V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3a4.27 4.27 0 0 1-3.24-1.48z"/>
  </svg>
);

const LINKS = [
  ['facebook', 'Facebook', 'https://www.facebook.com/THEPBBAPP/', Facebook],
  ['instagram', 'Instagram', 'https://www.instagram.com/pbbapp/', Instagram],
  ['linkedin', 'LinkedIn', 'https://www.linkedin.com/in/harriet-butler-79a37185/', Linkedin],
  ['youtube', 'YouTube', 'https://www.youtube.com/@THEPBBApp', Youtube],
  ['tiktok', 'TikTok', 'https://www.tiktok.com/@pbbapp', TikTok],
];

export const FooterSocialLinks = () => (
  <div className="mt-5" data-testid="footer-social">
    <div className="text-white font-semibold mb-2 text-sm">Follow us</div>
    <ul className="flex flex-wrap gap-2.5">
      {LINKS.map(([key, label, href, Icon]) => (
        <li key={key}>
          <a href={href} target="_blank" rel="noopener noreferrer" aria-label={`PBB on ${label}`} title={label}
            data-testid={`footer-social-${key}`}
            className="w-11 h-11 rounded-full bg-neutral-800 text-white flex items-center justify-center transition-colors hover:bg-green-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-green-500">
            <Icon size={18}/>
          </a>
        </li>
      ))}
    </ul>
  </div>
);
